import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../stempz-logo.svg';

const Terms: React.FC = () => {
    return (
        <div className="min-h-screen bg-white">
            {/* Header */}
            <header className="bg-teal-600 text-white py-6">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/" className="text-2xl font-bold hover:text-teal-100 transition-colors inline-flex items-center gap-2">
                        <img src={logo} alt="" className="h-8 w-8 brightness-0 invert" />
                        Stempz
                    </Link>
                </div>
            </header>

            {/* Content */}
            <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-4xl">
                <h1 className="text-4xl font-bold text-gray-900 mb-8">Vilkår for bruk</h1>

                <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
                    <p className="text-sm text-gray-500">Sist oppdatert: 26. januar 2026</p>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Aksept av vilkår</h2>
                        <p>
                            Ved å laste ned, installere eller bruke Stempz-appen ("Tjenesten"), godtar du disse
                            vilkårene for bruk. Hvis du ikke godtar vilkårene, skal du ikke bruke Tjenesten.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Beskrivelse av tjenesten</h2>
                        <p>
                            Stempz er en digital plattform for lojalitetskort som lar brukere samle stempler
                            hos våre partnerbedrifter. Tjenesten er gratis for forbrukere.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Brukerkonto</h2>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li>Du må oppgi et gyldig telefonnummer for å opprette en konto.</li>
                            <li>Du er ansvarlig for å holde kontoinformasjonen din sikker.</li>
                            <li>Du må være minst 13 år for å bruke Tjenesten.</li>
                            <li>Én person kan kun ha én konto.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Lojalitetskort og stempler</h2>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li>Stempler kan kun samles ved faktiske kjøp hos våre partnere.</li>
                            <li>Belønninger bestemmes av hver enkelt partnerbedrift.</li>
                            <li>Vi forbeholder oss retten til å ugyldiggjøre stempler oppnådd gjennom svindel.</li>
                            <li>Stempler og belønninger kan ikke overføres til andre brukere.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Forbudt bruk</h2>
                        <p>Du samtykker i å ikke:</p>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li>Bruke Tjenesten til ulovlige formål</li>
                            <li>Forsøke å manipulere eller jukse med stempelsystemet</li>
                            <li>Dele kontoen din med andre</li>
                            <li>Kopiere, modifisere eller distribuere Tjenesten</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Endringer i tjenesten</h2>
                        <p>
                            Vi forbeholder oss retten til å endre, suspendere eller avslutte Tjenesten
                            når som helst, med eller uten varsel.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Ansvarsfraskrivelse</h2>
                        <p>
                            Tjenesten leveres "som den er" uten garantier av noe slag. Vi er ikke ansvarlige
                            for tap eller skader som følge av bruk av Tjenesten.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Endringer i vilkårene</h2>
                        <p>
                            Vi kan oppdatere disse vilkårene fra tid til annen. Fortsatt bruk av Tjenesten
                            etter endringer utgjør aksept av de nye vilkårene.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Gjeldende lov</h2>
                        <p>
                            Disse vilkårene er underlagt norsk lov. Eventuelle tvister skal avgjøres
                            av norske domstoler.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">10. Kontakt</h2>
                        <p>
                            Har du spørsmål om disse vilkårene? Kontakt oss på{' '}
                            <a href="mailto:hello@stempz.no" className="text-teal-600 hover:underline">
                                hello@stempz.no
                            </a>
                        </p>
                    </section>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-gray-900 text-gray-400 py-8 mt-12">
                <div className="container mx-auto px-4 text-center">
                    <p>© {new Date().getFullYear()} Stempz. Alle rettigheter reservert.</p>
                </div>
            </footer>
        </div>
    );
};

export default Terms;
